import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperMarkerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getMotionTransition
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    number: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    isReduceMotionEnabled,
    durations,
    isCurrent,
    measures,
    radiuses,
    borders,
    colors
}: StepperMarkerDynamicStyleType) => {
    const transition = getMotionTransition({
        properties: [
            "background-color",
            "border-color"
        ],
        isReduceMotionEnabled,
        intent: "hover",
        durations
    });

    const styles = {
        container: {
            borderWidth: isCurrent ? measures.line : borders.line,
            backgroundColor: colors.markerBackgroundColor,
            borderColor: colors.markerBorderColor,
            borderRadius: radiuses.full,
            height: measures.markerSize,
            width: measures.markerSize,
            ...webStyle(transition)
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
